import React from 'react'
import { Container, Input } from './style'

export default () => (
  <Container>
    <Input placeholder='search in wbba' />
  </Container>
)